export default __webpack_public_path__ + "static/media/icon_sign_out_profile.f1b8475c.svg";